import { render, staticRenderFns } from "./EastViewFooter.vue?vue&type=template&id=3f2f2f64&scoped=true"
import script from "./EastViewFooter.vue?vue&type=script&lang=js"
export * from "./EastViewFooter.vue?vue&type=script&lang=js"
import style0 from "./EastViewFooter.vue?vue&type=style&index=0&id=3f2f2f64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2f2f64",
  null
  
)

export default component.exports